import React from 'react';
// import PropTypes from 'prop-types';

const RefreshStatus = ({ text = "Please refresh the page to get current status" }) => {
  return (
    <div className="se-flex se-items-center se-justify-center se-gap-2 se-rounded-md">
      <img src="/images/info_icon.png" className='se-w-3' alt='' />
      <span className="se-text-xs se-font-medium se-text-gray-600">{text}</span>
    </div>
  );
};

// RefreshStatus.propTypes = {
//   text: PropTypes.string.isRequired
// };

export default RefreshStatus;